import React from 'react';
import { Droplet } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { services } from '../../data/siteData';

export const Services = () => {
  return (
    <section id="services" className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-blue-50" data-testid="services-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-blue-100 text-[#0205B3] px-4 py-2 rounded-full text-sm font-medium mb-4">
            <Droplet className="h-4 w-4" fill="currentColor" />
            <span>Nos prestations</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Nettoyage costumes, chemises, robes de mariée, manteaux, cuir : Pressing professionnel en Essonne
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            <strong>Pressing et teinturerie en Essonne (91)</strong>. <strong>Nettoyage à sec de costumes homme, tailleurs femme, chemises, robes de mariée, robes de soirée, manteaux, doudounes, vestes en cuir, blousons de motard</strong>. <strong>Repassage professionnel, entretien literie, nettoyage couettes, dessus-de-lit, rideaux</strong> et tous textiles délicats. Également <strong>spécialistes du nettoyage de tapis (persan, oriental, kilim, berbère) et moquettes</strong>.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => (
            <Card
              key={service.title}
              className="group hover:shadow-2xl transition-all duration-300 border-0 bg-white hover:-translate-y-2"
              data-testid={`service-card-${service.title}`}
            >
              <CardContent className="p-8">
                <div className="bg-gradient-to-br from-blue-100 to-blue-100 rounded-2xl w-16 h-16 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <service.icon className="h-8 w-8 text-[#0205B3]" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {service.description}
                </p>
                <ul className="space-y-2">
                  {service.items.map((item) => (
                    <li key={item} className="flex items-center text-sm text-gray-700">
                      <div className="h-1.5 w-1.5 rounded-full bg-blue-500 mr-2"></div>
                      {item}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
